var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-group-toggle-wrapper"},[_c('FormToggleButton',{attrs:{"toggleLabelHTML":_vm.toggle.label,"defaultActive":_vm.active,"toggleLeftLabel":_vm.toggle.left,"toggleRightLabel":_vm.toggle.right},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }